// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1___022e587c49312831715","cls2":"SearchBar-cls2___80b58f38be9589b646e SearchBar-cls1___022e587c49312831715"};